import React from "react";
import styles from "./about.module.css";
import aboutImg from "../../assets/images/about.jpeg"
import { Tent, Flame, Utensils, Compass } from "lucide-react";

const AboutCampsite = () => {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.container}>

        {/* Left Image Section */}
        <div className={styles.imageSection}>
          <div className={styles.imageWrapper}>
            <img src={aboutImg} alt="Beautiful Campsite" className={styles.image} />
          </div>
        </div>

        {/* Right Text Section */}
        <div className={styles.textSection}>
          <h2 className={styles.heading}>About Us</h2>
          
          <p className={styles.leadText}>
            Escape the city and immerse yourself in the beauty of nature.
            At Dima Niwas Campsite, we provide a serene and safe environment for adventurers, families, and nature lovers.
          </p>
          
          <p className={styles.description}>
            Experience cozy tents, lakeside relaxation, guided nature trails, and evening bonfires under the stars.
            We focus on comfort, safety, and a truly immersive outdoor experience.
          </p>

          {/* Quick Features Grid */}
          <div className={styles.featuresGrid}>
            <div className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <Tent size={22} color="#267444" />
              </div>
              <div className={styles.featureContent}>
                <h4 className={styles.featureTitle}>Cozy Tents</h4>
                <p className={styles.featureDesc}>Comfortable, safe stays in nature</p>
              </div>
            </div>

            <div className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <Flame size={22} color="#267444" />
              </div>
              <div className={styles.featureContent}>
                <h4 className={styles.featureTitle}>Bonfire Nights</h4>
                <p className={styles.featureDesc}>Warm gatherings under the stars</p>
              </div>
            </div>

            <div className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <Utensils size={22} color="#267444" />
              </div>
              <div className={styles.featureContent}>
                <h4 className={styles.featureTitle}>Lakeside Dining</h4>
                <p className={styles.featureDesc}>Fresh local cuisine by the water</p>
              </div>
            </div>

            <div className={styles.featureItem}>
              <div className={styles.featureIcon}>
                <Compass size={22} color="#267444" />
              </div>
              <div className={styles.featureContent}>
                <h4 className={styles.featureTitle}>Boating & Sports</h4>
                <p className={styles.featureDesc}>Exciting water adventures</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutCampsite;
